export const PUFVProfessorGestorPermissions = {
  id: 'pufv_professor_gestor',

  navbar: {
    view: true,
    profile: {
      edit: true,
      perfilBeta: false,
    },
  },

  projetos: {
    list: true,
    register: true,
    edit: true,
    approve: false,
    reprove: false,
    editFinished: false,
    remove: false,
    viewChecker: {
      professorGestor: true,
      coordenadorLocal: false,
    },
    filters: {
      situacao: true,
      coop: true,
    },
  },

  reembolsos: {
    list: false,
    register: false,
    edit: false,
    remove: false,
  },

  professores: {
    list: true,
    register: true,
    edit: true,
    approve: true,
    reprove: true,
    activate: true,
    deactivate: true,
    canRemove: false,
  },

  assessores: {
    list: false,
    register: false,
    edit: false,
    activate: false,
    deactivate: false,
    canRemove: false,
  },

  coordenadores: {
    list: false,
    register: false,
    edit: false,
    activate: false,
    deactivate: false,
    canRemove: false,
  },

  empresas: {
    list: false,
    register: false,
    edit: false,
    remove: false,
  },

  escolas: {
    list: true,
    register: true,
    edit: true,
    activate: true,
    deactivate: true,
    dadosDaEscola: {
      list: true,
      register: true,
      edit: true,
      duplicate: true,
      remove: true,
    },
    ideb: {
      list: true,
      register: true,
      edit: true,
      remove: true,
    },
  },

  relatorios: {
    generate: {
      projetos: true,
      'dados-cadastrais': true,
      'dados-gerais': true,
      'dados-do-programa': true,
      assessoria: false,
      'dados-do-ideb': true,
      contratos: false,
      escolas: true,
    },
  },

  agendaAssessoresPedagogicos: {
    list: false,
    register: false,
    edit: {
      locked: false,
      unlocked: false,
    },
    lock: false,
    unlock: false,
    remove: [false, false, false, false, false],
  },

  materiaisPedagogicos: {
    list: true,
    download: true,
  },

  dashboard: {
    generate: false,
  },

  contratos: {
    list: false,
    editEvenWhenDisabled: false,
    assessor: {
      allStatus: [],
      edit: false,
      register: false,
      view: false,
      upload: false,
      changeUpload: false,
      changeStatus: false,
      analiseOperacional: {
        edit: false,
      },
      templates: {
        list: false,
        edit: false,
      },
    },
    entePublico: {
      allStatus: [],
      downloadChecklist: false,
      edit: false,
      register: false,
      view: false,
      uploadNaoAssinado: false,
      uploadAssinado: false,
      uploadExtrato: false,
      changeUploadAssinado: false,
      changeUploadExtrato: false,
      changeUploadPlanoTrabalho: false,
      changeStatus: false,
      analiseOperacional: {
        edit: false,
      },
    },
    entePrivado: {
      allStatus: [],
      edit: false,
      register: false,
      view: false,
      upload: false,
      changeUpload: false,
      changeStatus: false,
      analiseOperacional: {
        edit: false,
      },
      templates: {
        list: false,
        edit: false,
      },
    },
  },
};
